module.exports = __webpack_public_path__ + "media/images/credit-card-types-cb79abba2715f6f6df58f0fa3debbd87.svg";